"use client"

import { QRCodeSVG } from "qrcode.react"

import { appStoreCampaignUrl, type AppIntent } from "@/lib/app-store-campaign"
import { cn } from "@/lib/utils"

/**
 * Desktop-to-phone App Store handoff QR. Encodes the campaign URL for the
 * placement so a camera scan lands in App Store Connect under the same
 * `pt`/`ct`/`mt` attribution as the placement's badge click. The `_qr` suffix
 * keeps scans separable from clicks on the same surface.
 */
export function AppStoreQrCode({
  placement,
  intent,
  size = 72,
  className,
  title = "QR code linking to What Grass Is This? on the App Store",
}: {
  placement: string
  intent?: AppIntent
  size?: number
  className?: string
  title?: string
}) {
  const qrPlacement = placement.endsWith("_qr") ? placement : `${placement}_qr`
  const value = appStoreCampaignUrl(qrPlacement, intent)
  if (!value) return null

  return (
    <QRCodeSVG
      value={value}
      size={size}
      level="M"
      marginSize={0}
      fgColor="#111827"
      title={title}
      className={cn("shrink-0 bg-white", className)}
    />
  )
}
